// extracted by mini-css-extract-plugin
export default {"true":"Button_true__L01xK","false":"Button_false__T9jTS"};